export default __webpack_public_path__ + "static/media/groups-icon.5d917b1a.svg";